import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.963 11.144A7.5 7.5 0 0 0 12 18.5a1 1 0 1 1-2 0q0-.737.113-1.46a4 4 0 0 0-.608-.04H9.5a4.5 4.5 0 0 0 0 9h10a7.5 7.5 0 0 0 1.463-14.856M10.63 15.097A9.5 9.5 0 1 1 19.5 28h-10a6.5 6.5 0 0 1-.003-13M9.262 3.153a1 1 0 0 1 1.16.81l.525 2.95a1 1 0 1 1-1.969.35l-.525-2.95a1 1 0 0 1 .81-1.16M2.806 7.264a1 1 0 0 1 1.393-.245L6.66 8.744a1 1 0 0 1-1.147 1.638L3.05 8.657a1 1 0 0 1-.245-1.393M6.072 13.863a1 1 0 0 1-.81 1.16l-2.95.524a1 1 0 1 1-.35-1.969l2.95-.525a1 1 0 0 1 1.16.81M16.736 4.806a1 1 0 0 1 .246 1.393l-1.725 2.463a1 1 0 0 1-1.639-1.148l1.726-2.462a1 1 0 0 1 1.392-.246"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.066 8.446a5 5 0 0 0-6.994 5.417c.16.891.554 1.725 1.14 2.415a1 1 0 0 1-1.524 1.295 7.14 7.14 0 0 1-1.585-3.358v-.004a7 7 0 0 1 13.285-4.068 1 1 0 0 1-1.826.815 5 5 0 0 0-2.496-2.512"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCloudSun = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCloudSun);
export default Memo;
